import { render, staticRenderFns } from "./RemoveConsumer.vue?vue&type=template&id=1ec3b4ac"
import script from "./RemoveConsumer.vue?vue&type=script&lang=js"
export * from "./RemoveConsumer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports